export default __webpack_public_path__ + "static/media/sb-title-en.3531b9d1.webp";